import { render, staticRenderFns } from "./AgButton.vue?vue&type=template&id=4b396782&"
import script from "./AgButton.vue?vue&type=script&lang=js&"
export * from "./AgButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports